import type IconBuilder from '~/components/patterns/icons/builders/iconsData/IconBuilder';
import createIconBuilderFromCondUiKit from './condUiKitAdapter';


// cond-ui-kit icon data (from @conductor/cond-ui-kit/lib/components/icons/ProductIcon/IcoMoonData/plug.json)
const plugIconData = {
	icon: {
		attrs: [{}],
		grid: 0,
		isMulticolor: false,
		isMulticolor2: false,
		paths: [
			'M228.23 452.262c17.283-14.093 42.768-13.077 58.875 3.032l281.61 281.594c17.181 17.181 17.178 45.035 0 62.219l-76.797 76.811c-26.531 26.531-80.254 55.934-141.328 65.189-52.398 7.939-113.358 1.36-168.626-36.859l-99.656 99.67-3.344 3.016c-17.28 14.091-42.767 13.088-58.875-3.016-17.183-17.182-17.183-45.051 0-62.234l99.656-99.672c-38.209-55.262-44.782-116.216-36.844-168.61 9.255-61.070 38.657-114.782 65.188-141.312l76.798-76.797 3.342-3.032zM210.309 594.31c-11.869 11.869-33.659 47.755-40.406 92.28-6.397 42.219 1.205 87.891 40.406 127.094 39.203 39.203 84.875 46.802 127.094 40.406 44.526-6.747 80.413-28.538 92.282-40.406l45.686-45.688-219.374-219.374-45.688 45.688zM945.027 17.060c17.283-14.093 42.784-13.077 58.891 3.031 17.178 17.182 17.178 45.037 0 62.219l-99.672 99.657c38.219 55.266 44.798 116.226 36.859 168.624-9.253 61.075-38.656 114.798-65.187 141.328l-76.813 76.798c-17.182 17.178-45.037 17.179-62.218 0l-20.094-20.094-71.282 71.296c-17.181 17.179-45.035 17.176-62.219 0-17.182-17.182-17.182-45.051 0-62.234l71.282-71.298-116.984-116.968-71.282 71.298-3.344 3.014c-17.28 14.093-42.766 13.090-58.874-3.014-17.184-17.184-17.184-45.053 0-62.235l71.28-71.298-20.078-20.077c-17.182-17.184-17.182-45.037 0-62.219l76.798-76.797c26.53-26.53 80.24-55.933 141.312-65.188 52.394-7.938 113.347-1.365 168.61 36.844l99.672-99.656 3.342-3.031zM813.685 210.31c-39.205-39.202-84.875-46.803-127.094-40.406-44.525 6.746-80.413 28.538-92.282 40.406l-45.686 45.686 219.374 219.376 45.688-45.688c11.869-11.869 33.659-47.755 40.406-92.282 6.395-42.218-1.205-87.891-40.406-127.093z',
		],
		tags: ['plug', 'integration', 'api', 'data'],
	},
	attrs: [{}],
	properties: {
		code: 59770,
		id: 13,
		name: 'plug',
		order: 3441,
		prevSize: 20,
	},
	setIdx: 0,
	setId: 2,
	iconIdx: 1,
};

// Create IconBuilder from cond-ui-kit data
const IntegrationsIconBuilder: IconBuilder = createIconBuilderFromCondUiKit(
	plugIconData as any,
	'#89c32e', // Default green color for new navigation
);

export default IntegrationsIconBuilder;
